/** Dynamic Y-axis for club-conditions percentage charts (values often 1–40%, not 0–100%). */

export function getPercentageAxisMax(values: number[], minCap = 8, maxCap = 100): number {
  const numeric = values.filter((v) => Number.isFinite(v) && v >= 0);
  if (numeric.length === 0) {
    return minCap;
  }
  const peak = Math.max(...numeric);
  if (peak <= 0) {
    return minCap;
  }
  const padded = peak * 1.2;
  const rounded = Math.ceil(padded);
  return Math.min(maxCap, Math.max(minCap, rounded));
}

export function percentageYScale(values: number[], baseYScale: Record<string, unknown> = {}) {
  const max = getPercentageAxisMax(values);
  const step = max <= 20 ? 2 : max <= 50 ? 5 : 10;

  return {
    ...baseYScale,
    min: 0,
    max,
    ticks: {
      ...(baseYScale as { ticks?: Record<string, unknown> }).ticks,
      stepSize: step,
      callback(value: number | string) {
        return `${Number(value).toFixed(0)}%`;
      },
    },
  };
}
